var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShip(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 15,
    viewBox: "0 0 20 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_724_1199)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.5737 1.3273C10.5737 1.14656 10.4271 1 10.2464 1H9.75899C9.5782 1 9.43164 1.14656 9.43164 1.3273V2.35483H10.5737V1.3273Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.8645 6.3898L13.2113 3.10325C13.1793 2.94262 13.0384 2.8269 12.8746 2.8269H7.12963C6.96584 2.8269 6.82489 2.94262 6.79294 3.10325L6.13965 6.3898L10.0021 5.68567L13.8645 6.3898ZM10.2828 3.53427H12.5128L12.7303 4.84086H10.2828V3.53427ZM9.72138 4.84086H7.27391L7.49146 3.53427H9.72138V4.84086Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.10118 11.5456C8.86687 11.5456 9.81645 12.0629 10.5794 12.4786C11.2536 12.8459 11.786 13.1358 12.9393 13.1358C13.4069 13.1358 13.7699 13.0895 14.08 13.0106C15.3106 9.92136 15.6903 7.45619 15.6903 7.45619L10.0019 6.25708L4.31348 7.45623C4.31348 7.45623 4.59219 9.26535 5.44568 11.7261C5.95294 11.6053 6.49862 11.5456 7.10118 11.5456Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.6474 13.0821C14.9873 13.4416 14.3047 13.8132 12.9397 13.8132C11.5747 13.8132 10.9051 13.4488 10.1969 13.063C9.43883 12.65 8.65496 12.2229 7.10147 12.2229C5.54797 12.2229 4.76424 12.65 4.00618 13.0629L4 13.0663L4.35272 13.7138L4.3589 13.7105C5.06705 13.3247 5.7359 12.9603 7.10147 12.9603C8.46703 12.9603 9.13602 13.3247 9.84421 13.7105C10.6023 14.1235 11.3862 14.5505 12.9397 14.5505C14.4932 14.5505 15.2934 14.1144 16 13.7296L15.6474 13.0821Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_724_1199"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 13.5504,
    fill: "white",
    transform: "translate(4 1)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShip);
export default __webpack_public_path__ + "static/media/ship.d99d0c805e49b56d1b75b4fc69649658.svg";
export { ForwardRef as ReactComponent };